var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRfqBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1998_92485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8208 8.61323C13.8218 8.54791 13.7909 8.48608 13.7382 8.44764L6.30865 3.01544C6.23919 2.96475 6.14543 2.96354 6.07487 3.01231L2.73896 5.3169C2.68449 5.35458 2.65186 5.41667 2.65186 5.48289C2.65186 5.54911 2.68444 5.6112 2.73896 5.64888L10.3852 10.9312C10.4197 10.9551 10.4598 10.967 10.4999 10.967C10.5399 10.967 10.5801 10.9551 10.6145 10.9312L13.7337 8.77634C13.7876 8.73932 13.82 8.67854 13.8208 8.61323Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7143 6.49571C18.6479 6.46096 18.5676 6.46575 18.5058 6.50837L11.01 11.6871C10.9555 11.7247 10.9229 11.7868 10.9229 11.8531V19.7979C10.9229 19.8728 10.9645 19.9418 11.0309 19.9765C11.0604 19.992 11.0926 19.9996 11.1246 19.9996C11.1649 19.9996 11.205 19.9875 11.2392 19.9638L18.735 14.7852C18.7896 14.7476 18.8222 14.6854 18.8222 14.6192V6.67435C18.8223 6.59941 18.7806 6.53056 18.7143 6.49571Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99032 11.687L2.49442 6.50839C2.43273 6.46577 2.35254 6.46093 2.28606 6.49573C2.21969 6.53053 2.17798 6.59938 2.17798 6.67438V14.6192C2.17798 14.6854 2.21056 14.7475 2.26508 14.7852L9.76089 19.9638C9.79529 19.9875 9.83538 19.9996 9.87553 19.9996C9.90766 19.9996 9.93984 19.992 9.96929 19.9764C10.0357 19.9417 10.0773 19.8728 10.0773 19.7978V11.853C10.0774 11.7868 10.0449 11.7247 9.99032 11.687Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25827 2.52201L14.6879 7.95416C14.7234 7.98008 14.7651 7.99305 14.8069 7.99305C14.8469 7.99305 14.8871 7.98114 14.9216 7.95729L18.2608 5.65023C18.3154 5.61255 18.3479 5.55051 18.3479 5.48424C18.3479 5.41797 18.3154 5.35593 18.2608 5.31825L10.6146 0.0357468C10.5457 -0.0119156 10.4542 -0.0119156 10.3853 0.0357468L7.26266 2.19316C7.2089 2.23029 7.17646 2.29111 7.17556 2.35643C7.17465 2.42174 7.20557 2.48358 7.25827 2.52201Z",
    fill: "#1D4650"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1998_92485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfqBox);
export default __webpack_public_path__ + "static/media/rfq-box.cb70bd3bc88824abef376db381ffa5b8.svg";
export { ForwardRef as ReactComponent };